import { render, staticRenderFns } from "./OrderRegion.vue?vue&type=template&id=748ff948&scoped=true"
import script from "./OrderRegion.vue?vue&type=script&lang=js"
export * from "./OrderRegion.vue?vue&type=script&lang=js"
import style0 from "./OrderRegion.vue?vue&type=style&index=0&id=748ff948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748ff948",
  null
  
)

export default component.exports